const t = {
  name: "News",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 8H16V6H10V8Z" fill="currentColor"/>
<path d="M18 10H10V18H18V10ZM12 16V12H16V16H12Z" fill="currentColor"/>
<path d="M6 5C6 3.34315 7.34315 2 9 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H4V21.8293C2.83481 21.4175 2 20.3062 2 19V10C2 8.34315 3.34315 7 5 7H6V5ZM6 9H5C4.44772 9 4 9.44772 4 10V19C4 19.5523 4.44772 20 5 20C5.55228 20 6 19.5523 6 19V9ZM7.82929 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H9C8.44772 4 8 4.44772 8 5V19C8 19.3506 7.93985 19.6872 7.82929 20Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as News
};
